import React, { useEffect } from "react";
import { SocialLogin } from "./socialLogin";
import { useLogin } from "./useLogin";

export const Form = ({
    showOTPLoginOption = true,
    primaryInputLabel = "Email",
    showForgotPassword = true,
    showSocialLogin = true,
    source = null,
    sendEvent = (clickedOn: string) => { }
}) => {

    const { handleLogin, otpSent, setOTPSent, setIntentId, email, setEmail, error, setError, otpLogin, password, setPassword, timer, sendOTP, otp, setOTP, showResendSuccessMsg, setOTPLogin, socialLoginEnabled } = useLogin({ primaryInputLabel, showSocialLogin, sendEvent, source })

    const getEmailFromUrl = () => {
        const hash = window.location.hash;
        if (!hash.includes('?')) return null;
        const queryString = hash.split('?')[1];
        if (!queryString) return null;
        return new URLSearchParams(queryString).get('funnelfox_email');
    };

    useEffect(() => {
        const emailFromUrl = getEmailFromUrl();
        if (emailFromUrl && !email) {
            setEmail(emailFromUrl);
        }
    }, []);

    return (
        <form onSubmit={handleLogin} autoComplete="on">
            <div className="login-form">
                <div className="login-box">
                    <div className="form-field">
                        <label>
                            {primaryInputLabel}
                            {otpSent && otpLogin && <a onClick={() => {
                                setOTPSent(false);
                                setIntentId(null);
                                sendEvent(`Change ${primaryInputLabel}`);
                            }}>Change {primaryInputLabel}</a>}
                        </label>
                        <input
                            value={email}
                            type="email"
                            placeholder={`Enter ${primaryInputLabel}`}
                            autoFocus={true}
                            tabIndex={1}
                            disabled={otpSent}
                            readOnly={otpSent}
                            onChange={({ target }) => {
                                error && setError(null);
                                setEmail(target?.value);
                            }}
                            autoComplete="sl-user-login-email"
                            name="sl-user-login-email"
                            data-test-id="user-login"
                        />
                        {otpLogin && otpSent && (
                            <p className="info">
                                We’ve sent a verification code to the email above.
                            </p>
                        )}
                        {otpLogin && !otpSent && error && <p className="info error">{error}</p>}
                    </div>
                    {!otpLogin && (
                        <div className="form-field">
                            <label>
                                Password{" "}
                                {showForgotPassword && (
                                    <a target="_blank" onClick={() => sendEvent("Forgot Password")} href="/forgot_password" tabIndex={4}>
                                        Forgot password?
                                    </a>
                                )}
                            </label>
                            <input
                                value={password}
                                type="password"
                                placeholder="Enter Password"
                                tabIndex={2}
                                onChange={({ target }) => {
                                    error && setError(null);
                                    setPassword(target?.value);
                                }}
                                autoComplete="sl-user-login-password"
                                name="sl-user-login-password"
                                data-test-id="user-password"
                            />
                            {error && <p className="info error">{error}</p>}
                        </div>
                    )}
                    {otpLogin && otpSent && (
                        <div className="form-field">
                            <label data-test-id="enter-verification-code">
                                Enter Verification code{" "}
                                <a
                                    className={`${timer ? "disabled otp-timer" : ""}`}
                                    onClick={() => sendOTP()}
                                >
                                    Resend code
                                    {timer ? (
                                        <>
                                            {" "}
                                            in <strong>{timer}s</strong>
                                        </>
                                    ) : (
                                        ""
                                    )}
                                </a>
                            </label>
                            <div className="otp-text">
                                <input
                                    type="text"
                                    className="otp"
                                    maxLength={6}
                                    autoComplete="off"
                                    onChange={({ target }) => {
                                        error && setError(null);
                                        setOTP(target?.value);
                                    }}
                                    autoFocus={true}
                                    value={otp}
                                    data-test-id="otp-input"
                                />
                                <input className="autocomplete" type="email" readOnly />
                                {["", "", "", "", "", ""].map((char, index) => (
                                    <div className="otp-box">{otp?.[index] || ""}</div>
                                ))}
                            </div>
                            {error && <p className="info error">{error}</p>}
                            {showResendSuccessMsg && (
                                <p className="info success">
                                    <i className="iconcust-iconCheck" /> A new verification code
                                    has been sent.
                                </p>
                            )}
                        </div>
                    )}
                    <button data-test-id="login-submit-button" onClick={handleLogin} tabIndex={3}>
                        {otpLogin ? "Submit" : "Login"}
                    </button>
                    {otpLogin && otpSent && (
                        <p className="email-info">
                            If you are not seeing the email, the email may have landed in your spam folder, or your account may be associated with a different email.
                        </p>
                    )}
                </div>
                {showOTPLoginOption && (
                    <div
                        tabIndex={5}
                        className="other-login-box"
                        onClick={() => {
                            setOTPLogin((value) => !value);
                            setError(null);
                            sendEvent(`Login via ${otpLogin ? "Password" : "Verification Code"}`);
                        }}
                        data-test-id="verification-code-hypertext"
                    >
                        Login via <a>{otpLogin ? "Password" : "Verification Code"}</a>
                    </div>
                )}
                {socialLoginEnabled && (
                    <>
                        <div className="or-bar">
                            <p className="or-bar-text">or Login with</p>
                        </div>
                        <SocialLogin />
                    </>
                )}
            </div>
        </form>
    )
}